__turbopack_context__.v({
  "MenuItem": "index-module__ndxiaG__MenuItem",
  "MenuPopup": "index-module__ndxiaG__MenuPopup",
  "MenuPositioner": "index-module__ndxiaG__MenuPositioner",
  "MenuSeparator": "index-module__ndxiaG__MenuSeparator",
  "MenuTrigger": "index-module__ndxiaG__MenuTrigger",
  "Menubar": "index-module__ndxiaG__Menubar",
  "SubmenuTrigger": "index-module__ndxiaG__SubmenuTrigger",
});
